var map = {
	"./pages": [
		4812,
		908,
		812
	],
	"./pages/": [
		4812,
		908,
		812
	],
	"./pages/index": [
		4812,
		908,
		812
	],
	"./pages/index.js": [
		4812,
		908,
		812
	],
	"./pages/pokemon/id": [
		5771,
		908,
		771
	],
	"./pages/pokemon/id.js": [
		5771,
		908,
		771
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1455;
module.exports = webpackAsyncContext;